<template lang="pug">
  .container.grid-xl
    page-title(title="Compra" icon="fas fa-shopping-cart" subtitle="Detalhes da compra")
    .flex-centered.content-full-height(v-if="loading") #[.loading.loading-lg]
    div(v-else-if="!error && purchase")
      .columns
        .column.col-4.col-md-6.col-sm-12
          card-person.height-100(:person="purchase.person" title="Comprador")
        .column.col-4.col-md-6.col-sm-12
          card-info.height-100(title="Detalhes da compra" icon="fas fa-shopping-cart")
            .card-body(slot="card-body")
              .text-ellipsis Status: #[small(:class="purchaseStatus.class") {{ purchase.status | purchaseStatus }}]
              .text-ellipsis Gateway: #[span.text-bold(:class="gateway.class") {{ gateway.label }}]
              .text-ellipsis Valor: #[span.text-bold(:class="purchase.status === 'canceled' ? 'line-through' : 'text-success'") {{ purchase.total | currency('R$ ') }}]
              .text-ellipsis ID no gateway: #[span.text-bold {{ purchase.externalId }}]
              .text-ellipsis Comprado em: #[span.text-bold {{ purchase.createdAt | toDate('DD/MM/YYYY HH:mm') }}]
              .text-ellipsis(v-if="purchase.refund") Cancelado em: #[span.text-bold {{ purchase.refund.createdAt | toDate('DD/MM/YYYY HH:mm') }}]
        .column.col-4.col-md-6.col-sm-12
          card-info.height-100(title="Cupom de desconto" icon="fas fa-ticket-alt")
            .card-body(v-if="purchase.personCoupon" slot="card-body")
              .columns
                .column.col-12.text-ellipsis Código: #[span.text-bold {{ coupon.code }}]
                .column.col-12.text-ellipsis Tipo de desconto: #[span.text-bold(:class="discountType.class") {{ discountType.label }}]
                .column.col-12.text-ellipsis Valor: #[span.text-bold(:class="discountType.class") {{ coupon.value | currency(...discountType.filter) }}]
                .column.col-12.text-ellipsis Criador: #[span.text-bold {{ coupon.creator.fullName }}]
            .card-body.flex-entered(v-else slot="card-body")
              .text-center.mt-2
                i.fas.fa-ticket-alt.fa-3x
                .text-center Nenhum cupom utilizado
      .py-2.my-2
        .divider.text-center(data-content="Itens da compra")
      card-info.mt-2(:title="`Esta compra possui ${purchase.purchaseItems.length} itens`" icon="fas fa-sitemap")
        .card-body(slot="card-body")
          table.table.table-responsive
            thead
              tr
                th Título
                th.text-center(width="1") Data de publicação
            tbody
              tr(v-for="purchaseItem in purchase.purchaseItems")
                td.text-ellipsis {{ purchaseItem.productItem.title }}
                td.text-center.text-ellipsis {{ purchaseItem.productItem.publishDate | toDate }}
    .flex-centered.content-full-height(v-else-if="error") #[error-box(:error="error")]
</template>

<script>
import purchases from '@/services/purchases'
import { mapGateway, discountTypes, purchaseStatus } from '@/lib/constants'

export default {
  data() {
    return { loading: false, error: null, purchase: null }
  },
  computed: {
    purchaseStatus() {
      return purchaseStatus[this.purchase.status] || {}
    },
    gateway() {
      return mapGateway[this.purchase.paymentGatewayType]
    },
    coupon() {
      if (!this.purchase.personCoupon) return null
      return this.purchase.personCoupon.coupon
    },
    discountType() {
      return discountTypes[this.coupon.discountType]
    },
  },
  async created() {
    try {
      this.loading = true
      const { id } = this.$route.params
      const { data } = await purchases.show(id)
      this.purchase = data
    } catch (e) {
      this.error = e
    } finally {
      this.loading = false
    }
  },
}
</script>
